<template>
  <div class="shop-page" v-loading="loadingAll">
    <PageHeader
      :title="loading.shopInfo ? `Chargement du magasin...` : `Magasin ${shopInfo.name}`"/>
    <PageContainer size="small">
      <el-tabs>
        <el-tab-pane
          v-if="$store.getters['permissions/canViewApplicationControlTab']"
          label="Prise de contrôle applications">
          <ShopApplicationsTab
            :loadingToken="loading.shopToken"
            :shopId="shopId"
            :shop-type="shopType"
            :shop-token="shopToken"
          />
        </el-tab-pane>
        <el-tab-pane
          v-if="$store.getters['permissions/canViewSynchronizationTab']"
          label="Etat synchronisation"
        >
          <el-button
            type="primary"
            icon="el-icon-user"
            @click="showAddUserDialog">
            Créer un utilisateur
          </el-button>
          <el-button
            disabled
            type="secondary"
            icon="el-icon-magic-stick"
            @click="syncAllUsers"
            v-loading="syncUsersLoading">
            Resynchroniser le magasin
          </el-button>
          <AddUserDialog
            v-if="displayAddUserDialog"
            @close="hideAddUserDialog"
            @onUserAdded="handleUserAdded"/>
          <div style="margin-top: 40px;"></div>
          <el-row
            :gutter="20">
            <el-col :span="24" v-if="loading.shopSyncStats">
              <Card v-loading="loading.shopSyncStats">
                Chargement des informations de synchronisation
              </Card>
            </el-col>
            <el-col
              :span="8"
              :sm="8"
              :xs="24"
              v-loading="loading.shopSyncStats"
              v-for="appStats in shopUsersStats.shopSyncStats"
              :key="appStats.displayName"
            >
              <Card :disabled="!appStats.implemented">
                <div>
                  <el-row>
                    <div v-if="appStats.implemented && appStats.shop">
                      <h3>{{ appStats.displayName }}</h3>
                      <div class="separated-list">
                  <span>Magasin créé :
                  <i v-if="appStats.shopExists" class="el-icon-circle-check" style="color: green">
                  </i>
                   <i v-else class="el-icon-circle-close" style="color: #ff0000"></i>
                  </span>
                      </div>
                      <!-- -->
                      <div class="separated-list" v-if="appStats.shop">
                        <div v-if="appStats.shop.contactPoint">
                          <span>Points de contact :</span>
                          <ul>
                            <li
                              v-for="(contactPoint, index) in appStats.shop.contactPoint"
                              :key="index">
                              {{ index }} : {{ contactPoint }}
                            </li>
                          </ul>
                        </div>
                      </div>
                      <!-- -->
                      <div class="separated-list" v-if="appStats.shop">
                        <span>Email: {{ appStats.shop.email }}</span>
                      </div>
                      <div class="separated-list">
                        <span>Nombre d'utilisateurs: {{ appStats.shopUsersCount }}</span>
                      </div>
                    </div>
                    <div v-if="appStats.implemented && !appStats.shop" style="height: 100%;">
                      <h3>{{ appStats.displayName }}</h3>
                      <span>Magasin manquant</span>
                    </div>
                    <div v-if="!appStats.implemented" style="height: 100%;">
                      <h3>{{ appStats.displayName }}</h3>
                      <span>Application non supportée pour le moment.</span>
                    </div>
                  </el-row>
                </div>
              </Card>
            </el-col>
          </el-row>
          <div style="margin-top: 40px;"></div>
          <el-row :gutter="15">
            <el-col :span="24">
              <Table
                v-loading="loading.shopUsers"
                :columns="columns"
                :data="transformedData"
                :paginable="true">
              </Table>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane
          v-if="$store.getters['permissions/canViewIntranetControlTab'] && !isPortugalShop"
          label="Prise contrôle intranet">
          <div style="margin-top: 40px;"></div>
          <el-row :gutter="15">
            <el-col :span="24">
              <Table
                v-loading="loading.shopIntranetUsers"
                :columns="shopIntranetUsersColumns"
                :data="transformedIntranetData"
                :paginable="true">
              </Table>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </PageContainer>
  </div>
</template>
<script>
import services from 'services';
import PageHeader from '@/components/PageHeader/PageHeader.vue';
import PageContainer from '@/components/PageContainer/PageContainer.vue';
import Table from '@/components/Table/Table.vue';
import Card from '@/components/Card/Card.vue';
import AddUserDialog from '@/views/pages/ShopPage/AddUserDialog.vue';
import ShopApplicationsTab from '@/views/pages/ShopPage/ShopApplicationsTab.vue';
import _ from 'lodash';
import { firestore } from 'firebase';
import * as dayjs from 'dayjs';

export default {
  components: {
    PageHeader,
    PageContainer,
    Table,
    Card,
    AddUserDialog,
    ShopApplicationsTab,
  },
  props: {
    shopId: { type: String, required: true },
    shopType: { type: String, required: true },
  },
  async mounted() {
    if (!this.shopType) {
      this.$message.error('Le type de magasin est maquant.');
    }
    await this.fetchData();
  },
  data() {
    return {
      loadingAll: false,
      loading: {
        shopInfo: true,
        shopToken: true,
        shopUsers: true,
        shopSyncStats: true,
        shopIntranetUsers: true,
      },
      syncUsersLoading: false,
      shopToken: null,
      shopInfo: { name: '', id: this.shopId },
      shopUsers: [],
      shopUsersStats: [],
      shopIntranetUsers: [],
      searchQuery: '',
      columns: {
        // id: { key: 'id', label: 'ID', sortable: false },
        firstname: { key: 'firstname', label: 'Prénom', sortable: false },
        lastname: { key: 'lastname', label: 'Nom', sortable: false },
        role: { key: 'role', label: 'Role', sortable: false },
        status: { key: 'status', label: 'Status', sortable: false },
        lastPasswordUpdate: { key: 'lastPasswordUpdate', label: 'Modification MDP', sortable: false },
      },
      shopIntranetUsersColumns: {
        // id: { key: 'login', label: 'ID', sortable: false },
        firstname: { key: 'prenom', label: 'Prénom', sortable: false },
        lastname: { key: 'nom', label: 'Nom', sortable: false },
        role: { key: 'type_user', label: 'Role', sortable: false },
        button: {
          type: 'button',
          buttonConfig: {
            size: 'mini',
            buttonText: 'contrôler',
            onClick: (scope, row) => {
              this.takeIntranetUserControl(row.login, row.code);
            },
          },
        },
      },
      displayAddUserDialog: false,
    };
  },
  methods: {
    postIntranetLoginForm(username, password) {
      const form = document.createElement('form');
      form.setAttribute('target', '_blank');
      form.setAttribute('method', 'post');
      form.setAttribute('name', 'login');
      form.setAttribute('action', 'https://intranet.blachere.fr/intranet_new/log.php');


      const hiddenField1 = document.createElement('input');
      hiddenField1.setAttribute('type', 'hidden');
      hiddenField1.setAttribute('name', 'username');
      hiddenField1.setAttribute('value', username);
      form.appendChild(hiddenField1);

      const hiddenField2 = document.createElement('input');
      hiddenField2.setAttribute('type', 'hidden');
      hiddenField2.setAttribute('name', 'password');
      hiddenField2.setAttribute('value', password);
      form.appendChild(hiddenField2);

      document.body.appendChild(form);

      form.submit();
    },
    async takeIntranetUserControl(login, code) {
      this.loadingAll = true;
      const password = await services.shopService.getIntranetUserPassword(code);
      this.postIntranetLoginForm(login, password);
      this.loadingAll = false;
    },
    async openApplicationOutils() {
      window.open(`${process.env.VUE_APP_OUTILS_APP_BASE_URL}?token=${this.shopToken}`, '_blank').focus();
    },
    async syncAllUsers() {
      this.syncUsersLoading = true;
      try {
        await services.shopService.syncAllUsers(this.shopId, this.shopToken);
      } catch {
        //
      }
      this.syncUsersLoading = false;
    },
    async fetchData() {
      try {
        /* eslint-disable */
        const promises = [
          services.shopService.getShopInfo(this.shopId, this.shopType).then((shopInfo) => {
            this.shopInfo = shopInfo;
            this.loading.shopInfo = false;
          }),
          services.shopService.getShopToken(this.shopId, this.shopType).then((shopToken) => {
            this.shopToken = shopToken;
            this.loading.shopToken = false;
          }),
          services.shopService.listShopUsers(this.shopId, this.shopType).then((shopUsers) => {
            this.shopUsers = shopUsers;
            this.loading.shopUsers = false;
          }),
        ];
        if (!this.isPortugalShop) {
          promises.push(
            services.shopService.shopUsersStats(this.shopId, this.shopType).then((shopUsersStats) => {
              this.shopUsersStats = shopUsersStats;
              this.loading.shopSyncStats = false;
            })
          );
          promises.push(
            services.shopService.listShopIntranetUsers(this.shopId, this.shopType).then((shopIntranetUsers) => {
              this.shopIntranetUsers = shopIntranetUsers;
              this.loading.shopIntranetUsers = false;
            })
          )
        }
        await Promise.all(promises);
        /* eslint-enable */
      } catch (e) {
        console.log('ERROR !!!', e);
        this.$message.error({
          message: 'Une erreur est survenue durant le chargement de ce magasin',
        });
      }
    },
    showAddUserDialog() {
      this.displayAddUserDialog = true;
    },
    hideAddUserDialog() {
      this.displayAddUserDialog = false;
    },
    handleUserAdded(user) {
      this.shopUsers.push(user.result);
    },
  },
  computed: {
    isPortugalShop() {
      return process.env.VUE_APP_ORGANIZATION === 'CDM_PRT';
    },
    isLoading() {
      return Object.values(this.loading).some((a) => a);
    },
    transformedData() {
      return this.filteredData.map((user) => {
        let lastPasswordUpdate = 'jamais';
        const lastUpdateSec = _.get(user, 'lastPasswordUpdate._seconds', null);
        const lastUpdateNano = _.get(user, 'lastPasswordUpdate._nanoseconds', null);

        if (lastUpdateSec && lastUpdateNano) {
          const date = new firestore.Timestamp(lastUpdateSec, lastUpdateNano);
          lastPasswordUpdate = dayjs(date.toDate()).format('DD/MM/YYYY');
        }
        return {
          ...user,
          lastPasswordUpdate,
        };
      });
    },
    transformedIntranetData() {
      return this.shopIntranetUsers.map((user) => user);
    },
    filteredData() {
      if (this.searchQuery.length === 0) {
        return this.shopUsers;
      }
      return this.shopUsers.filter((user) => (
        user.firstname.includes(this.searchQuery)
        || user.lastname.includes(this.searchQuery)
      ));
    },
  },
};
</script>
<style lang="stylus" scoped>
.shop-page {
  width: 100%;
}
.separated-list {
  margin-top: 10px;
  display: block;
  padding-bottom: 10px;
  margin-bottom : 10px;
  max-width: 100%;
  border-bottom: 1px whitesmoke solid;
}
</style>
